import { negativePrefix } from "./consts";

export interface NegationObject {
  value: string;
  negated: boolean;
}

export function extractNegation(input: string): NegationObject {
  return input.startsWith(negativePrefix)
    ? { value: input.replace(negativePrefix, ""), negated: true }
    : { value: input, negated: false };
}

export function isCurrentNegated(
  current: string,
  objects: NegationObject[],
): boolean {
  return objects.some(
    (object) => current.includes(object.value) && object.negated,
  );
}
